<template>
  <div class="modal custom-modal fade" id="add_contact" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Contact</h5>
          <button
            type="button"
            @click="clearRoute"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="createContact">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-form-label">
                    First Name
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="formCreateContact.first_name"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-form-label">Last Name</label>
                  <input
                    v-model="formCreateContact.last_name"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>
                Email Address
                <!-- <span class="text-danger">*</span> -->
              </label>
              <input
                v-model="formCreateContact.email"
                class="form-control"
                type="email"
              />
            </div>
            <div class="form-group">
              <label>
                No Whatsapp
                <span class="text-danger">*</span>
              </label>
              <input
                v-model="formCreateContact.phone_number"
                class="form-control"
                type="text"
              />
            </div>
            <div class="form-group">
              <label> Birth Date </label>
              <div class="row">
                <div class="col-sm-2" style="margin: 5px">
                  <div class="onoffswitch">
                    <input
                      type="checkbox"
                      name="onoffswitch"
                      v-model="formCreateContact.birth_date_is_filled_checkbox"
                      class="onoffswitch-checkbox"
                      id="birth_date_is_filled_checkbox"
                    />
                    <label
                      class="onoffswitch-label"
                      for="birth_date_is_filled_checkbox"
                    >
                      <span class="onoffswitch-inner"></span>
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                </div>
                <div class="col-sm-8">
                  <input
                    v-show="formCreateContact.birth_date_is_filled_checkbox"
                    v-model="formCreateContact.birth_date_data"
                    class="form-control"
                    type="date"
                  />
                </div>
              </div>
            </div>

            <div class="form-group"> 
              <!-- {{ groupListArr }} -->
              <label class="d-block">Group</label>
              <div class="d-flex">
                <span class="input-group-text" id="basic-addon1"
                  ><i class="fa fa-search"></i
                ></span>
                
                <a-select
                  show-search
                  placeholder="Search Group" 
                  :filter-option="false" 
                  @focus="getGroupList('')"
                  mode="multiple"
                  @search="getGroupList" 
                  v-model="formCreateContact.list_id"
                >
                  <a-select-option v-for="item in groupListArr" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                  <template #notFoundContent>
                    <a-divider style="margin: 4px 0;" />
                    <div
                      style="padding: 4px 8px; cursor: pointer;"
                      @mousedown="e => e.preventDefault()"
                      @click="addNewGroup"
                    >
                      <a-icon type="plus" /> Add Group "{{ searchQuery }}"
                    </div>
                  </template>
                  
                </a-select>
                <!-- <a-select
                  v-model="formCreateContact.list_id"
                  show-search
                  mode="multiple"
                  @search="getGroupList"
                  @search:focus="getGroupList('')"
                  style="width: 100%"
                  :options="groupListArr"
                  placeholder="Group Name"
                > 
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu" />
                    <a-divider style="margin: 4px 0" />
                    <div style="padding: 4px 8px; cursor: pointer">
                      <a-icon type="plus" /> Add item
                    </div>
                  </div>
                </a-select> -->
              </div>
              <!-- <div class="task-wrapper">
                <div class="task-list-container">
                  <div class="input-group ">
                    <span class="input-group-text" id="basic-addon1"><i class="fa fa-search"></i></span>
                    <input v-model="filter" type="text" class="form-control" placeholder="Group Name"
                      aria-label="Group Name" aria-describedby="basic-addon1">
                  </div>
                  <div class="task-list-body">
                    <ul id="task-list">
                      <li style="cursor:pointer" v-if="groupListFilterArr.length == 0" @click="addNewGroup(filter)">
                        <div class="task-container">
                          <p class="task-label text-center" contenteditable="false">
                            <i class="fa fa-plus-circle"></i>
                            <span>Add Group - {{ filter }}</span>
                          </p>
                        </div>
                      </li>
                      <template v-for="rowG in groupListFilterArr">
                        <li v-on:click="selectGroup(rowG.id);" v-bind:id="rowG.id" class="task" :class="{
                          'completed': formCreateContact.list_id.includes
                            (rowG.id)
                        }" :key="rowG.id">
                          <div class="task-container">
                            <span class="task-action-btn task-check">
                              <span class="action-circle large complete-btn" title="Select">
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <span class="task-label" contenteditable="false">{{ rowG.name }}</span>
                          </div>
                        </li>
                      </template>
                      <template v-for="rowG in groupListArr">
                        <li v-on:click="selectGroup(rowG.id);" v-bind:id="rowG.id" class="task" :key="rowG.id">
                          <div class="task-container">
                            <span class="task-action-btn task-check">
                              <span class="action-circle large complete-btn" title="Select">
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <span class="task-label" contenteditable="false">{{ rowG.name }}</span>
                          </div>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  components: {
    Skeleton,
    vSelect,
  },
  data() {
    return {
      filter: "",
      loadingGroup: false,
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000,
      },
      searchQuery :'',
      loading: false,
      // formCreateContact: {
      //   email: "",
      //   phone_number: "",
      //   first_name: "",
      //   last_name: "",
      //   list_id: [],
      //   birth_date_data: "",
      //   birth_date_is_filled_checkbox: false,
      //   birth_date_is_filled: 0,
      // },
    };
  },
  watch: {
    showAddContact: {
      handler: function (val, oldVal) {
        // console.log("val", val);
        // console.log("oldVal", oldVal);
        // if (val != "") {
        //   this.viewContact(val);
        // }
        if (val == "1") {
          this.resetForm();
          this.getGroupList();
        }
      },
      deep: true,
    },
  },
  computed: {
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    },
    selectedGroupArr() {
      return this.formCreateContact.list_id.map((i) => {
        return { id: i };
      });
    },
    groupListFilterArr() {
      // Jika input pencarian kosong, tampilkan semua item
      if (!this.filter.trim()) {
        return this.groupListArr;
      }
      // Jika tidak, filter item berdasarkan pencarian
      return this.groupListArr.filter((item) => {
        // Menggunakan metode 'LIKE' untuk pencarian yang mirip
        return item.name.toLowerCase().includes(this.filter.toLowerCase());
      });
    },
    formCreateContact: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  props: {
    showAddContact: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: () => ({
        email: "",
        phone_number: "",
        first_name: "",
        last_name: "",
        list_id: [],
        birth_date_data: "",
        birth_date_is_filled_checkbox: false,
        birth_date_is_filled: 0,
      }),
    },
  },
  methods: {
    addNewGroup() {
      this.$store
        .dispatch("contact/createGroup", {
          name: this.searchQuery,
          description: "",
        })
        .then((response) => {
          this.$fire({
            title: "Success",
            text: "Group added successfully",
            type: "success",
            timer: 1000,
          });
          // this.getGroupList();
          this.formCreateContact.list_id.push(response.id);
        });
    },
    clearRoute() {
      this.$router.replace({
        query: {},
      });
      this.resetForm();
    },
    async getGroupList(param = null) {
      if (param !== null) {
        this.groupListParam.name = param;
        this.searchQuery = param;
      }
      this.loadingGroup = await false;
      let debounce;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => { 
        await this.$store
          .dispatch("contact/getGroupList", this.groupListParam) // sesuai kan dengan method di API
          .catch((error) => {
            this.loadingGroup = false;
          });
      }, 300);
    },
    async createContact() {
      if (this.formCreateContact.birth_date_is_filled_checkbox == true) {
        this.formCreateContact.birth_date_is_filled = 1;
      } else {
        this.formCreateContact.birth_date_is_filled = 0;
      }
      let inputForm = {
        ...this.formCreateContact,
        list_id: this.selectedGroupArr,
      };
      await this.$store
        .dispatch("contact/createContact", inputForm)
        .then((response) => {
          // this.formCreateContact.list_id.forEach((value, index) => {
          //   var element = document.getElementById(value.id);
          //   element.classList.remove("completed");
          // });
          this.formCreateContact = {
            email: "",
            phone_number: "",
            first_name: "",
            last_name: "",
            list_id: [],
            birth_date_data: "",
            birth_date_is_filled_checkbox: false,
            birth_date_is_filled: 0,
          };

          this.$fire({
            title: "Success",
            text: "Data added successfully",
            type: "success",
            timer: 1000,
          }).then((r) => {});
        });
      // .catch(error => {
      //   console.log("errrrrr", error);
      //   this.$fire({
      //     title: "Error",
      //     text: error.msg,
      //     type: "error",
      //     timer: 1000
      //   }).then(r => {});
      // });
    },
    resetForm() {
      this.formCreateContact = {
        email: "",
        phone_number: "",
        first_name: "",
        last_name: "",
        list_id: [],
        birth_date_data: "",
        birth_date_is_filled_checkbox: false,
        birth_date_is_filled: 0,
      };
    },
    async selectGroup(id) {
      var dataArr = { id: id };
      var element = document.getElementById(id);
      if (this.formCreateContact.list_id.length > 0) {
        var isFound = false;
        var indexFound = -1;
        await this.formCreateContact.list_id.forEach((value, index) => {
          if (value.id === id) {
            indexFound = index;
          }
        });

        if (indexFound >= 0) {
          element.classList.remove("completed");
          this.formCreateContact.list_id.splice(indexFound, 1);
        } else {
          // this.$refs
          element.classList.add("completed");
          this.formCreateContact.list_id.push(dataArr);
        }
      } else {
        element.classList.add("completed");
        this.formCreateContact.list_id.push(dataArr);
      }
    },
  },
  async created() {},
  mounted() {},
  name: "create-contacts",
};
</script>



// WEBPACK FOOTER //
// src/views/contacts/createContact.vue